import React, { Component } from 'react'
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {playButtonTap} from './PlaySounds';

class GameModeScreen extends Component {

      goToPlayScreen = (mode) => {
        playButtonTap();
        localStorage.setItem('game_mode',mode);
        this.props.history.push('/gamemodeintro');
      };
      goToMainMenu = () => {
        playButtonTap();
        this.props.history.push('/mainmenu');
    };
    

    render() {
            return(
                <div className = "screen_background">
                  <div className = "buttons_wrapper">
                    <img src={"/game-skins/build-rev79-TUGQhb2Uf/images_"+this.props.language+"/btn_time_challange.png"} alt="" className="button home_button" onClick = {() => this.goToPlayScreen("time")}/><br/>
                    <img src={"/game-skins/build-rev79-TUGQhb2Uf/images_"+this.props.language+"/btn_free_play.png"} alt="" className="button home_button" onClick = {() => this.goToPlayScreen("free")}/><br/>
                    <img src={"/game-skins/build-rev79-TUGQhb2Uf/images_"+this.props.language+"/btn_back.png"} alt="" className="button home_button back_button" onClick = {this.goToMainMenu}/><br/>
                  </div>
                  
                </div>
            )
    }
}

GameModeScreen.propTypes = {
  language:PropTypes.string.isRequired
}

const mapStateToProps = state =>({
  language: localStorage.getItem('language',"en")
});

export default connect(mapStateToProps)(GameModeScreen);
//export default withRouter(MainMenuScreen);



// WEBPACK FOOTER //
// ./src/components/GameModeScreen.js